import styled from 'styled-components';

export const InvisibleButton = styled.button`
  all: unset;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./components/atoms/InvisibleButton.js